import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';

const ChangeProfesionalAdmission = ({ closeModal, opened, data, callbackHealthProfessional }) => {

    //Articulos
    const [profesionals, setProfesionals] = useState([]);
    const [idProfesional, setIdProfesional] = useState(null);

    //Sistema
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("success");

    useEffect(() => {
        console.log("dataAdmission", data);
        getAllProfessionals();
    }, []);

    const confirmedUpdateChangeProfessional = () => {
        let newProfesional = profesionals.find(prof => prof.id_profesional == idProfesional);
        callbackHealthProfessional(data.id_admision,newProfesional);
    }

    const onOkModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            confirmedUpdateChangeProfessional();
        }
        if (colorAlertModal == "warning") {
            saveNewProfessional();
        }
    }

    const onToggleModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            confirmedUpdateChangeProfessional();
        }
    }

    const getAllProfessionals = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error consultando los Profesionales")
            }
        }).then(res => {
            setProfesionals(res.filter(dat => dat.nombre_profesional.toUpperCase() != data.nombre_profesional.toUpperCase()));
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const saveNewProfessional = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/update-doctor', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_admision: data.id_admision,
                id_profesional: idProfesional
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error cambiando el Profesional")
            }
        }).then(res => {
            setAlertColorModal("success");
            setAlertMessageModal("El Profesional en Salud se ha cambiado Exitosamente");
            setAlerShowModal(true);
        }).catch((error) => {
            console.error('Error:', error);
            setAlertColorModal("error");
            setAlertMessageModal("Ha ocurrido un error en el Sistema");
            setAlerShowModal(true);
        });
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                disableEnforceFocus={true}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Cambiar Profesional en Salud</h5>
                        </div>
                        <Row>
                            <Col md={6}>
                                <TextField
                                    label="Profesional Actual"
                                    value={data.nombre_profesional.toUpperCase()}
                                    disabled={true}
                                    onChange={(event) => {
                                        //setActualProfessional(event.target.value);
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    label="Elección de Profesional"
                                    value={idProfesional}
                                    onChange={(event) => {
                                        setIdProfesional(event.target.value);
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    select
                                >
                                    {profesionals.map((prof) => {
                                        return (
                                            <MenuItem key={prof.id_profesional} value={prof.id_profesional} >
                                                {prof.nombre_profesional}
                                            </MenuItem>);
                                    })}
                                </TextField>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                setAlertColorModal("warning");
                                setAlertMessageModal("Esta seguro de cambiar el Profesional en Salud? Esta acción puede afectar otros procesos");
                                setAlerShowModal(true);
                            }}
                        >
                            Guardar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOkModal()}
                toggle={() => onToggleModal()}
            />
        </div>
    );
};
export default ChangeProfesionalAdmission;
